import _module from 'module.js'
import ExtensionNotRecommendedTemplate
  from '../views/common/extensionNotRecommendedTemplate.html'

class ExtensionNotRecommendedController {
  constructor (
    gettextCatalog,
    $mdDialog,
  ) {
    'ngInject'
    this.gettextCatalog = gettextCatalog
    this.$mdDialog = $mdDialog
  }

  complete () {
    this.$mdDialog.hide(true)
  }

  cancel () {
    this.$mdDialog.cancel()
  }
}

class ExtensionNotRecommendedPopup {
  constructor (
    $mdDialog,
    gettextCatalog,
  ) {
    'ngInject'
    this.$mdDialog = $mdDialog
    this.gettextCatalog = gettextCatalog
  }

  open () {
    return this.$mdDialog.show({
      template: ExtensionNotRecommendedTemplate,
      controllerAs: 'ctrl',
      controller: ExtensionNotRecommendedController,
      locals: {
        $mdDialog: this.$mdDialog,
        gettextCatalog: this.gettextCatalog,
      },
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      fullscreen: true
    })
  }
}

_module.service('extensionNotRecommendedPopup', ExtensionNotRecommendedPopup)
